import { render } from "./MenuColecciones.vue?vue&type=template&id=db6f8644&scoped=true"
import script from "./MenuColecciones.vue?vue&type=script&lang=js"
export * from "./MenuColecciones.vue?vue&type=script&lang=js"

import "./MenuColecciones.vue?vue&type=style&index=0&id=db6f8644&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-db6f8644"

export default script